import Axios from 'config/axios';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateConstant } from 'store/actions/constantAction';

const url = '/api_v2/options/WEATHER_REPORT';

const useWeatherReport = () => {
    const WEATHER_REPORT = useSelector((state) => state.constants.weather_report);
    const dispatch = useDispatch();

    const [weatherReport, setWeatherReport] = useState({
        WR_CATEGORIES: [],
        WR_EMOTIONS: [],
        WR_ZOR: [
            { label: 'Ready to learn', value: 'Green' },
            { label: 'In a state of processing', value: 'Yellow' },
            { label: 'Not quite ready to learn', value: 'Blue' },
            { label: 'Heightened state of emotion', value: 'Purple' },
            { label: 'Emotional overload', value: 'Red' },
        ],
    });

    useEffect(() => {
        const fetchData = async () => {
            if (WEATHER_REPORT) {
                setWeatherReport({ ...WEATHER_REPORT, WR_ZOR: weatherReport.WR_ZOR });
            } else {
                const response = await Axios.get(url);
                const data = response.data.option;
                dispatch(updateConstant('weather_report', data));
                setWeatherReport(data);
            }
        };

        fetchData();
    }, [WEATHER_REPORT, dispatch]);

    return weatherReport;
};

export default useWeatherReport;
